import React, { useEffect } from 'react'

import { EcomWrapperEvent } from "@payair/e-com-wrapper-sdk/models/EcomWrapperEvent"
import { SrciEvent } from "@payair/srci-sdk/models/SrciEvent"
import { SrciButtonParams } from "@payair/srci-sdk/models/SrciButtonParams"
import { SrciInitParams } from "@payair/srci-sdk/models/SrciInitParams"

import { EcomWrapperEventListenerEnumsObj } from "@payair/e-com-wrapper-sdk/enums/EcomWrapperEventListenerEnum"
import { SrciEventTypeEnumsObj } from "@payair/srci-sdk/enums/SrciEventTypeEnum"
import { EcomWalletSdkEnumsObj } from "@payair/e-com-wrapper-sdk/enums/EcomWalletSdkEnum"
import { SrciButtonSizeEnum } from "@payair/srci-sdk/enums/SrciButtonSizeEnum"
import { PaymentMethodEnum } from "@payair/srci-ui-sdk/types/enums/PaymentMethodEnum"

import { SrciDcfParams } from "@payair/srci-sdk/models/SrciDcfParams"
import { DcfSdkEnumsObj } from "@payair/srci-sdk/enums/DcfSdkEnum"

import PayairEcomWrapperSdk from "@payair/e-com-wrapper-sdk"
import store from '../../store/SrciStore'
import { SrciVisaDpaTransactionOptions } from '@payair/srci-sdk/models/SrciVisaDpaTransactionOptions'
import { SrciMastercardDpaTransactionOptions } from '@payair/srci-sdk/models/SrciMastercardDpaTransactionOptions'
import { SrciVisaPaymentOptions } from '@payair/srci-sdk/models/SrciVisaPaymentOptions'
import { buildSrciConsumerPrefill } from '../../helpers/buildSrciConsumerPrefill'

const ecomWrapperSdk = PayairEcomWrapperSdk.ecomWrapperSdk

export default function SrciWallet() {
  useEffect(() => {
    window.addEventListener(EcomWrapperEventListenerEnumsObj.PAYAIR_ECOM_WRAPPER_SDK_LISTENER, event =>
      onEcomWrapperListenerEvent(event)
    )

    initCheckout()
  })

  const onEcomWrapperListenerEvent = (ecomWrapperListenerEvent: any) => {
    const event: EcomWrapperEvent | SrciEvent = ecomWrapperListenerEvent.detail
    console.log("onEcomWrapperListenerEvent:", event)

    switch (event.sdk) {
      case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
          onSrciSdkEvent(event)
        break
      default:
        break
    }
  }

  const onSrciSdkEvent = (srciSdkEvent: SrciEvent) => {
    switch (srciSdkEvent.eventType) {
      case SrciEventTypeEnumsObj.SDK_INITIALIZE_SUCCESS:
      case SrciEventTypeEnumsObj.SDK_REINITIALIZED:
          renderSrciButton();
        break;     
      default:
        break
    }
  }

  const renderSrciButton = () => {
    const srcButtonParams = store.getState().srciInputData.buttonParams
    const srciButtonParams: SrciButtonParams = {
      buttonColor: "black",
      buttonSize: srcButtonParams.buttonsize as SrciButtonSizeEnum,
      buttonType: srcButtonParams.paymentmethod as PaymentMethodEnum,
    }

    ecomWrapperSdk.renderButton(EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK, "srciButton", srciButtonParams)
  }

  const initCheckout = async () => {
    initSrc()
  }

  const initSrc = () => {

    const srcDcfCheckoutParams = store.getState().srciInputData.dcfCheckoutParams
    
    const visaSrciVisaPaymentOptions: SrciVisaPaymentOptions = {
      dpaDynamicDataTTLMinutes: undefined,
      dynamicDataType: undefined,
      dpaPanRequested: undefined
    }

    const srcVisaDpaTransactionOptions = store.getState().srciInputData.srciInitVisa.dpaTransactionOptions
    const visaDpaTransactionOptions: SrciVisaDpaTransactionOptions = {
      dpaLocale: srcVisaDpaTransactionOptions.dpaLocale,
      dpaAcceptedBillingCountries: srcDcfCheckoutParams.dpaTransactionOptions.dpaAcceptedBillingCountries,
      dpaAcceptedShippingCountries: srcDcfCheckoutParams.dpaTransactionOptions.dpaAcceptedShippingCountries,
      dpaBillingPreference: srcVisaDpaTransactionOptions.dpaBillingPreference,
      dpaShippingPreference: srcVisaDpaTransactionOptions.dpaShippingPreference,
      consumerNameRequested: srcVisaDpaTransactionOptions.consumerNameRequested,
      consumerEmailAddressRequested: srcVisaDpaTransactionOptions.consumerEmailAddressRequested,
      consumerPhoneNumberRequested: srcVisaDpaTransactionOptions.consumerPhoneNumberRequested,
      paymentOptions: visaSrciVisaPaymentOptions,
      reviewAction: srcVisaDpaTransactionOptions.reviewAction,
      checkoutDescription: srcVisaDpaTransactionOptions.checkoutDescription,
      transactionType: srcVisaDpaTransactionOptions.transactionType,
      orderType: srcVisaDpaTransactionOptions.orderType,
      payloadTypeIndicator: srcVisaDpaTransactionOptions.payloadTypeIndicator,
      transactionAmount: srcVisaDpaTransactionOptions.transactionAmount,
      merchantOrderId: srcVisaDpaTransactionOptions.merchantOrderId,
      merchantCategoryCode: srcVisaDpaTransactionOptions.merchantCategoryCode,
      merchantCountryCode: srcVisaDpaTransactionOptions.merchantCountryCode,
      dpaDynamicDataTTLMinutes: srcVisaDpaTransactionOptions.dpaDynamicDataTTLMinutes,
      dynamicDataType: srcVisaDpaTransactionOptions.dynamicDataType,
      dpaPanRequested: srcVisaDpaTransactionOptions.dpaPanRequested,
    }

    const srcMastercardDpaTransactionOptions = store.getState().srciInputData.srciInitMastercard.dpaTransactionOptions
    const mastercardDpaTransactionOptions: SrciMastercardDpaTransactionOptions = {
      dpaAcceptedBillingCountries: srcDcfCheckoutParams.dpaTransactionOptions.dpaAcceptedBillingCountries,
      dpaAcceptedShippingCountries: srcDcfCheckoutParams.dpaTransactionOptions.dpaAcceptedShippingCountries,
      dpaBillingPreference: srcMastercardDpaTransactionOptions.dpaBillingPreference,
      dpaShippingPreference: srcMastercardDpaTransactionOptions.dpaShippingPreference,
      dpaLocale: srcMastercardDpaTransactionOptions.dpaLocale,
      consumerNameRequested: srcMastercardDpaTransactionOptions.consumerNameRequested,
      consumerEmailAddressRequested: srcMastercardDpaTransactionOptions.consumerEmailAddressRequested,
      consumerPhoneNumberRequested: srcMastercardDpaTransactionOptions.consumerPhoneNumberRequested,
      paymentOptions: srcMastercardDpaTransactionOptions.paymentOptions,
      transactionAmount: srcMastercardDpaTransactionOptions.transactionAmount,
      isGuestCheckout: srcMastercardDpaTransactionOptions.isGuestCheckout,
      customInputData: srcMastercardDpaTransactionOptions.customInputData,
      confirmPayment: srcMastercardDpaTransactionOptions.confirmPayment,
    }

    const mastercardDcfParams: SrciDcfParams = {
      srciIdentificator: {
        srcInitiatorId: store.getState().srciInputData.srciInitMastercard.srcInitiatorId,
        srciDpaId: store.getState().srciInputData.srciInitMastercard.srciDpaId,
      },
      dpaTransactionOptions: mastercardDpaTransactionOptions,
      srciDpaData: store.getState().srciInputData.dpaData,
    }

    const visaDcfParams: SrciDcfParams = {
      srciIdentificator: {
        srcInitiatorId: store.getState().srciInputData.srciInitVisa.srcInitiatorId,
        srciDpaId: store.getState().srciInputData.srciInitVisa.srciDpaId,
      },
      dpaTransactionOptions: visaDpaTransactionOptions,
      srciDpaData: store.getState().srciInputData.dpaData,
    }

    const srciMerchantId = new Map([
      [DcfSdkEnumsObj.MASTERCARD, mastercardDcfParams],
      [DcfSdkEnumsObj.VISA, visaDcfParams],
    ])

    const consumer = buildSrciConsumerPrefill(store.getState().srciInputData.dcfCheckoutParams.consumer)

    const srciInitParams: SrciInitParams = {
      currencyCode: store.getState().srciInputData.generalInput.currencyCode,
      totalAmount: store.getState().srciInputData.generalInput.totalAmount,
      totalAmountLabel: store.getState().srciInputData.generalInput.totalAmountLabel,
      merchantId: srciMerchantId,
      pspName: store.getState().srciInputData.generalInput.pspName,
      environment: store.getState().srciInputData.generalInput.environment,
      transactionId: store.getState().srciInputData.generalInput.transactionId,
      srciConsumer: consumer,
      srciBillingAddress: store.getState().srciInputData.srciInitVisa.dpaTransactionOptions.dpaBillingPreference !== "NONE"
        || store.getState().srciInputData.srciInitMastercard.dpaTransactionOptions.dpaBillingPreference !== "NONE"
        ? Object.values(store.getState().srciInputData.billingAddress).every(input => input === undefined || input === '') ? undefined : store.getState().srciInputData.billingAddress
        : undefined,
      locale: store.getState().srciInputData.generalInput.locale
    }

    console.log("srciInitParams", srciInitParams)

    ecomWrapperSdk.initSdk(EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK, srciInitParams)
  }

  return(
    <>
      <div id="srciButton" />
    </>
  )
}
